import { makeStyles, Theme, useMediaQuery } from "@material-ui/core";
import { FC } from "react";
import { ImageField, ImageInput } from "react-admin";

import rectangle from "../assets/rectangle.png";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `5px solid`,
    borderImage: `url(${rectangle}) 5 repeat`,
    padding: theme.spacing(1.5),
    boxSizing: "border-box",

    "& label": {
      display: "none",
    },

    "& .previews": {
      display: "flex",
      flexWrap: "wrap",
    },
  },
  dropZone: {
    backgroundColor: "transparent",
  },
  removeButton: {
    position: "relative",
    flexBasis: 200,
    margin: theme.spacing(0.5),
    borderRadius: 20,
    overflow: "hidden",

    "& button": {
      position: "absolute",
      right: 5,
      top: 5,
    },

    "& img": {
      height: "100%",
      objectFit: "cover",
      margin: 0,
      maxWidth: "100%",
    },
  },
}));

const ImageUploadInput: FC<ImageUploadInputProps> = ({ source, accept = "image/*", multiple = false, ...rest }) => {
  const classes = useStyles({});
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <ImageInput
      classes={{
        root: classes.root,
        dropZone: classes.dropZone,
        removeButton: classes.removeButton,
      }}
      multiple={multiple}
      source={source}
      accept={accept}
      style={{ maxWidth: isSm ? "200px" : "" }}
      {...rest}
    >
      <ImageField source="src" title="path" />
    </ImageInput>
  );
};

interface ImageUploadInputProps {
  source: string;
  accept?: string;
  multiple?: boolean;
  [key: string]: any;
}

export default ImageUploadInput;
